import { useEffect, useState } from 'react'
import { useQuery, useMutation } from 'react-query'
import API from '.'

const ENDPOINT = '/api/users'
const QUERY_KEY = 'users'
const QUERY_KEY_ME = 'me'

export const useGetUser = (userId, config = {}) =>
  useQuery([QUERY_KEY, userId], async () => (await API.get(`${ENDPOINT}/${userId}`)).data, config)

export const useMe = () => {
  const [user, setUser] = useState(null)
  const [firstRun, setFirstRun] = useState(true)
  const [enabled, setEnabled] = useState(true)
  const { isFetched, error, refetch } = useQuery(
    QUERY_KEY_ME,
    async () =>
      (
        await API.get(`${ENDPOINT}/me`).catch(async (err) => {
          if (err.response?.status === 401) {
            return { data: null }
          }
          throw err
        })
      ).data,
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: true,
      onSuccess: setUser,
    }
  )

  useEffect(() => {
    if (isFetched && firstRun) {
      setFirstRun(false)
    }
  }, [isFetched, firstRun])

  const fetchUser = async () => {
    //queryClient.invalidateQueries(QUERY_KEY_ME)
    refetch()
  }

  const clearUser = () => {
    setUser(null)
  }

  return {
    firstRun,
    setFirstRun,
    user,
    setUser,
    fetchUser,
    clearUser,
    error: error?.response?.status === 401 ? undefined : error,
    enabled,
    setEnabled,
  }
}

export const useGetUsers = (params) =>
  useQuery([QUERY_KEY, 'list', params], async () => (await API.get(`${ENDPOINT}`, { params })).data)

export const useCreateUser = (config = {}) =>
  useMutation((data) => API.post(ENDPOINT, data), config)

export const useEditUser = (config = {}) => useMutation((data) => API.patch(ENDPOINT, data), config)

export const useLogin = (config = {}) =>
  useMutation((data) => API.post(`${ENDPOINT}/login`, data), config)

export const useForgotPassword = (config = {}) =>
  useMutation((data) => API.post(`${ENDPOINT}/forgot-password`, data), config)

export const useResetPassword = (config = {}) =>
  useMutation((data) => API.patch(`${ENDPOINT}/reset-password`, data), config)

export const useCustomerEnquiry = (config = {}) =>
  useMutation((data) => API.post(`${ENDPOINT}/customer-enquiry`, data), config)

export const useLogout = (config = {}) => useMutation(() => API.post(`${ENDPOINT}/logout`), config)
